import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

interface AlertMessageProps {
  className?: string;
  message: string;
  success?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = (props) => {
  const { message, success, className } = props;
  const alertMessageClassNames = twMerge(
    'w-full p-2.5 rounded',
    success && 'bg-primary text-white',
    className,
  );
  return (
    <div className={alertMessageClassNames}>
      <Typography as="p" variant="body-large">
        {message}
      </Typography>
    </div>
  );
};

export default AlertMessage;
